export const planetChartData = {
  type: "line",
  data: {
    labels: ["January", "February", "March", "April", "May", "June", "July", "August"],
    datasets: [
      {
        label: "Number of blocked sites",
        data: [100, 100, 1, 2, 79, 82, 27, 14],
        backgroundColor: "#FFc1c1",
        borderColor: "#FF6666",
        borderWidth: 3
      },
      {
        label: "Number of allowed sites",
        data: [15, 51, 45, 45, 30, 50, 200, 100],
        backgroundColor: "rgba(71, 183,132,.5)",
        borderColor: "#47b784",
        borderWidth: 3
      }
    ]
  },
  options: {
    responsive: true,
    lineTension: 1,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            padding: 25
          }
        }
      ]
    }
  }
};

export default planetChartData;